import React, { Component } from 'react'
import StyleSheet from 'styles'
import Typography from '@material-ui/core/Typography'
import { humanize } from 'utils'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

export class ErrorBox extends Component{

  getErrors(errors=this.props.errors){
    const nonNullErrors = Object.values(this.props.errors).filter(x => x)
    if(!nonNullErrors.length)
      return []
    try{
      return nonNullErrors
               .map(x => Object.entries(x.meta))
               .reduce((mem, val) => mem.concat(val), [])
    }
    catch(err){
      return [["Error", ["Unknown error"]]]
    }
  }

  componentDidUpdate = prevProps => {
    const prevErrors = this.getErrors(prevProps.errors)
    const currentErrors = this.getErrors()
    if(`${prevErrors}` !== `${currentErrors}` && prevErrors.length && this._ref){
      this._ref.scrollIntoView()
    }
  }

  handleCameIntoView = ref => {
    this._ref = ref
    if(this._ref){
      this._ref.scrollIntoView()
    }
  }

  handleClearErrors = () => {
    this.props.onClearErrors && this.props.onClearErrors()
  }

  render = () => {
    const errorStrings = this.getErrors()

    return !!errorStrings.length ?  (
      <div ref={this.handleCameIntoView} className={styles.errorBox}>
        <IconButton className={styles.clear} onClick={this.handleClearErrors}>
          <CloseIcon/>
        </IconButton>
        {
          errorStrings.map(([key, value]) =>
            <Typography key={key} className={styles.error}>
              <span>{`${humanize(key)}: ${[...new Set(value)]}`}</span>
            </Typography>
          )
        }
      </div>
    ) : false
  }
}

const styles = StyleSheet({
  errorBox: {
    borderLeft: '4px solid #ad1010',
    padding: 10,
    background: '#f93f3f',
    color: '#d23232',
    margin: 10,
  },
  clear: {
    float: 'right',
    height: 20
  }
})
export default ErrorBox